import network from '@/services/network';
import { ErrorResponse } from '@/utils';
import {
  ReklamationListe,
  ReklamationSortierFeld,
  ReklamationStatusFilter,
} from '@/types/reklamation';

const getReklamationen = async (
  params: {
    alle?: number;
    status?: ReklamationStatusFilter;
    from?: string;
    to?: string;
    suche?: string;
    // Paginierung + Sortierung (Paket 3b). `sortieren` ist gegen die
    // BE-Whitelist validiert — alles andere ergibt 422.
    seite?: number;
    pro_seite?: number;
    sortieren?: ReklamationSortierFeld;
    richtung?: 'asc' | 'desc';
  } = {},
): Promise<{ data: ReklamationListe }> => {
  try {
    const { data } = await network.get<{ data: ReklamationListe }>('/reklamationen', { params });
    return data;
  } catch (error) {
    throw new ErrorResponse(error);
  }
};

const setzeBewertung = async (
  dealId: number,
  body: { anerkannt: 'ja' | 'nein' | null; bo_kommentar?: string | null },
): Promise<void> => {
  try {
    await network.post(`/reklamationen/${dealId}/bewertung`, body);
  } catch (error) {
    throw new ErrorResponse(error);
  }
};

const reklamationApi = { getReklamationen, setzeBewertung };

export default reklamationApi;
